import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AboutUs } from './pages/AboutUs';
import { Location } from './pages/Location';
import { Menu } from './pages/Menu';
import { Catering } from './pages/Catering';
import { Events } from './pages/Events';
import { Journal } from './pages/Journal';
import { JournalPost } from './pages/JournalPost';
import { Roasters } from './pages/Roasters';
import { RoasterProfile } from './pages/RoasterProfile';
import { Makers } from './pages/Makers';
import { Community } from './pages/Community';

/*
 * ─────────────────────────────────────────────────────────────────────────
 * ARCHIVED ROUTE: /memory-care-together
 *
 * The Memory Care Together campaign page is intentionally OFFLINE. The page
 * itself is fully preserved at pages/MemoryCareTogether.tsx — nothing was
 * deleted — so it can be brought back for next year's anniversary.
 *
 * TO RESTORE IT:
 *   1. Uncomment the import below and the <Route> inside <Routes>.
 *   2. Re-add the nav entry in components/HamburgerMenu.tsx (look for the
 *      "ARCHIVED" comment at the end of the menuItems array):
 *        { name: 'Memory Care Together', href: '/memory-care-together',
 *          icon: HandHeart }
 *      HandHeart must be re-added to that file's lucide-react import.
 *   3. Re-add the homepage teaser section in pages/LandingPage.tsx (look for
 *      the "ARCHIVED" comment between the Grounded Mornings and Visit Us
 *      sections). It also needs HandHeart back in its lucide-react import.
 *   4. Re-add the sitemap entry in public/sitemap.xml:
 *        <url>
 *          <loc>https://www.groundedlivermore.com/memory-care-together</loc>
 *          <lastmod>YYYY-MM-DD</lastmod>
 *          <changefreq>weekly</changefreq>
 *          <priority>0.8</priority>
 *        </url>
 *   5. Refresh the page copy for the new year — dates, event details, and
 *      the recap/upcoming framing in the intro and event cards.
 * ─────────────────────────────────────────────────────────────────────────
 */
// import { MemoryCareTogether } from './pages/MemoryCareTogether';

export function App() {
  return <Router data-id="element-0" data-mp="d3mlbefwx1lq">
      <Routes data-id="element-1" data-mp="d3cwhu6lt0hm">
        <Route path="/" element={<LandingPage data-id="element-3" data-mp="d2bf77yzvhrg" />} data-id="element-2" data-mp="d3wcv6glvgtj" />
        <Route path="/about" element={<AboutUs data-id="element-5" data-mp="86w60tbxma1d" />} data-id="element-4" data-mp="851mnjgb6pze" />
        <Route path="/location" element={<Location data-id="element-7" data-mp="3gl4sdjnv24l3" />} data-id="element-6" data-mp="83i39jzcvyte" />
        <Route path="/menu" element={<Menu data-id="element-9" data-mp="3glwabrojc3sw" />} data-id="element-8" data-mp="3gkl6jrv3aw1s" />
        <Route path="/catering" element={<Catering data-id="element-11" data-mp="3bmtjbb5e3y3x" />} data-id="element-10" data-mp="3gja35t5k3qb7" />
        <Route path="/events" element={<Events data-id="element-13" data-mp="3bo4l55f9yvse" />} data-id="element-12" data-mp="3bncorsdusu12" />
        <Route path="/journal" element={<Journal data-id="element-15" data-mp="3qbfvx53mubrg" />} data-id="element-14" data-mp="3qb7j1d7if6g9" />
        <Route path="/journal/:slug" element={<JournalPost data-id="element-17" data-mp="3qd0t72hc08t0" />} data-id="element-16" data-mp="3qbzf0p50r672" />
        <Route path="/roasters" element={<Roasters data-id="element-19" data-mp="3ljpiurdb99wc" />} data-id="element-18" data-mp="3ljxw4kdcih82" />
        <Route path="/roasters/:slug" element={<RoasterProfile data-id="element-21" data-mp="2xun01g6xxb09" />} data-id="element-20" data-mp="3lieeapc1jy46" />
        <Route path="/makers" element={<Makers data-id="element-23" data-mp="2xssfw43htmx8" />} data-id="element-22" data-mp="2xtlqxh9hiyl6" />
        <Route path="/community" element={<Community data-id="element-25" data-mp="2swlhcwdffdpb" />} data-id="element-24" data-mp="2svtm5mnqrhzk" />
        {/* ARCHIVED — see the note above to bring this back:
         <Route path="/memory-care-together" element={<MemoryCareTogether />} />
         */}
      </Routes>
    </Router>;
}